import React, { useRef, useEffect } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { Layout } from '@components';
import { Carousel } from 'react-responsive-carousel'; // Import your carousel library here
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Ensure styles are imported
import Image1 from '@images/coscape/1.png';
import Image2 from '@images/coscape/2.png';
import Image3 from '@images/coscape/3.png';

import { usePrefersReducedMotion } from '@hooks';

const StyledPageContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px; /* Set maximum width for the entire page */

  .project-tech-list {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
    margin: 25px 0 10px;
    padding: 0;
    list-style: none;

    li {
      margin: 0 20px 5px 0;
      color: var(--light-slate);
      font-family: var(--font-mono);
      font-size: var(--fz-xs);
      white-space: nowrap;
    }

    @media (max-width: 768px) {
      margin: 10px 0;

      li {
        margin: 0 10px 5px 0;
        color: var(--lightest-slate);
      }
    }
  }

  img {
    border-radius: var(--border-radius);
  }
  ul.skills-list {
    display: column;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-sans);
      font-size: var(--fz-xl);
      @media (max-width: 768px) {
        font-size: var(--fz-lg);
      }

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 24px;

        @media (max-width: 768px) {
          line-height: 20px;
        }
      }
    }
  }
`;

const StyledCarouselContainer = styled.div`
  margin: 50px auto; /* Adjust margin as needed */
`;

const PrigraPage = ({ location, data }) => {
  const revealTitle = useRef(null);
  const revealCarousel = useRef(null);
  const revealPara = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealTitle.current, srConfig());
    sr.reveal(revealPara.current, srConfig(200, 0));
    sr.reveal(revealCarousel.current, srConfig(400, 0));
  }, []);

  const tech = ['Flutter', 'Riverpod 2.0', 'Sqlite'];

  return (
    <Layout location={location}>
      <Helmet title="Coscape" />

      <StyledPageContainer>
        <main>
          <header>
            <h1 className="big-heading" ref={revealTitle}>
              Détails du projet
            </h1>
            <div ref={revealPara}>
              <p className="subtitle">Application Ecopocket</p>
              <p>
                Ecopocket est une application de suivi des dépenses et de gestion de budget. Elle
                permet de garder un œil sur ses dépenses du quotidien et de prendre des décisions
                financières plus éclairées.
                <br />
                <br />
                Fonctionnalités principales :
                <br />
                <br />
                - Suivi des dépenses personnelles
                <br />
                - Analyses hebdomadaires et mensuelles
                <br />
                - Gestion d’un budget par catégorie de dépense
                <br />
                - Interface minimaliste, pensée pour aller à l’essentiel
                <br />
                <br />
                <p>
                  J’ai porté tout le cycle de développement, du design UI/UX à la mise au point avec
                  les utilisateurs.
                </p>
              </p>
            </div>
          </header>

          <StyledCarouselContainer ref={revealCarousel}>
            <Carousel
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              autoPlay
              interval={3000}
              infiniteLoop>
              <div>
                <img src={Image3} alt="Image 3" />
              </div>
              <div>
                <img src={Image1} alt="Image 2" />
              </div>
              <div>
                <img src={Image2} alt="Image 1" />
              </div>
            </Carousel>
          </StyledCarouselContainer>
          <p className="subtitle">Technologies utilisées</p>
          {tech.length && (
            <ul className="project-tech-list">
              {tech.map((tech, i) => (
                <li key={i}>{tech}</li>
              ))}
            </ul>
          )}
        </main>
      </StyledPageContainer>
    </Layout>
  );
};

PrigraPage.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default PrigraPage;
